// CalendarNavBar.tsx — Nav-Zeile des Kalender-Neubaus:
//   [Heute] [‹] [›]   [▾ 22. Juni 2026]                         KW 26
// State/Navigation komplett aus useCalendarState(). REFINED-Optik, Touch-taugliche
// Maße (≥44px auf schmalen Screens) als Vorarbeit für SP6.

import React from "react";
import moment from "moment";
import "../../utils/momentDe"; // zentrale Locale-Quelle (de, Montag-Wochenstart, SP1)
import { useResponsive } from "../../hooks/useResponsive";
import { REFINED } from "../risikoanalyseStep/tokens";
import { useCalendarState } from "./CalendarStateContext";
import RdDatePicker from "./RdDatePicker";

const CalendarNavBar: React.FC = () => {
    const { currentDate, setCurrentDate, goToToday, goPrev, goNext } = useCalendarState();
    const { isPhone } = useResponsive();

    const tap = isPhone ? 44 : 36;
    const kw = moment(currentDate).isoWeek();

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                flexWrap: "wrap",
                padding: "8px 14px",
                borderBottom: `1px solid ${REFINED.line}`,
                background: REFINED.white,
            }}
        >
            <button type="button" onClick={goToToday} style={todayBtnStyle(tap)}>
                Heute
            </button>

            <div style={{ display: "flex", gap: 4 }}>
                <button
                    type="button"
                    aria-label="Zurück"
                    onClick={goPrev}
                    style={arrowBtnStyle(tap)}
                >
                    ‹
                </button>
                <button
                    type="button"
                    aria-label="Weiter"
                    onClick={goNext}
                    style={arrowBtnStyle(tap)}
                >
                    ›
                </button>
            </div>

            <RdDatePicker value={currentDate} onChange={setCurrentDate} />

            <span
                style={{
                    marginLeft: "auto",
                    color: REFINED.ink2,
                    font: `600 13px ${REFINED.fontUI}`,
                    letterSpacing: 0.3,
                }}
            >
                KW {kw}
            </span>
        </div>
    );
};

const todayBtnStyle = (h: number): React.CSSProperties => ({
    minHeight: h,
    padding: "0 14px",
    borderRadius: 8,
    border: `1px solid ${REFINED.line}`,
    background: REFINED.white,
    color: REFINED.ink,
    font: `600 14px ${REFINED.fontUI}`,
    cursor: "pointer",
});

const arrowBtnStyle = (h: number): React.CSSProperties => ({
    minWidth: h,
    minHeight: h,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 8,
    border: `1px solid ${REFINED.line}`,
    background: REFINED.white,
    color: REFINED.ink2,
    font: `600 18px ${REFINED.fontUI}`,
    lineHeight: 1,
    cursor: "pointer",
    padding: 0,
});

export default CalendarNavBar;
